import { getLiveCopy, getNewRequirementsCopy, getUploadCopy } from '../i18n.js';
import { getCurrentUser } from '../auth.js';
import { renderUploadView } from './UploadView.js';
import { canAccessLive } from '../versionAccess.js';

const html = String.raw;

export const renderNewRequirementsView = (container) => {
  const copy = getNewRequirementsCopy();
  const liveCopy = getLiveCopy();
  const uploadCopy = getUploadCopy();
  const user = getCurrentUser();
  const hasLiveFeature = canAccessLive(user);

  container.innerHTML = html`
    <div class="stack new-requirements-view" style="gap:24px;">
      <div class="view-header">
        <h1>${copy.title}</h1>
        ${copy.subtitle ? `<p class="muted">${copy.subtitle}</p>` : ''}
      </div>

      ${
        hasLiveFeature
          ? html`
              <section class="card stack new-requirements-live-card">
                <div class="row" style="justify-content: space-between; align-items: flex-start; gap: 16px; flex-wrap: wrap;">
                  <div class="stack tight" style="min-width: 220px;">
                    ${copy.live.badge ? `<span class="muted tiny">${copy.live.badge}</span>` : ''}
                    <h2 style="margin:0;">${copy.live.title || liveCopy.title}</h2>
                    ${copy.live.description ? `<p class="muted" style="margin:0;">${copy.live.description}</p>` : ''}
                  </div>
                  <div class="row" style="gap:8px;">
                    <button type="button" data-nav="#/live">${liveCopy.buttons.start}</button>
                    <button type="button" class="ghost-button" data-nav="#/live">${liveCopy.buttons.share}</button>
                  </div>
                </div>
                ${copy.live.note ? `<p class="muted tiny">${copy.live.note}</p>` : ''}
              </section>
            `
          : ''
      }

      <section class="new-requirements-upload" id="new-requirements-upload"></section>
      ${user?.plan?.name
        ? html`
            <section class="card stack">
              <p class="muted small" style="margin:0;">${uploadCopy.planNote}</p>
              <strong>${user.plan.name} (${user.plan.priceLabel})</strong>
              <button type="button" class="ghost-button" data-nav="#/profile">${uploadCopy.planNoteCta}</button>
            </section>
          `
        : ''}
    </div>
  `;

  container.querySelectorAll('[data-nav]').forEach((button) => {
    button.addEventListener('click', () => {
      window.location.hash = button.dataset.nav || '#/dashboard';
    });
  });

  const uploadContainer = container.querySelector('#new-requirements-upload');
  if (uploadContainer) {
    renderUploadView(uploadContainer, {
      variant: 'new-requirements',
      uploadTitle: copy.uploadTitle ?? uploadCopy.title,
      uploadFormatsHint: uploadCopy.formatsHint,
      transcriptFormatsHint: uploadCopy.transcript?.formatsHint,
      showPlanNote: false,
    });
  }
};
